import MaintenancePage from 'components/Maintenance/MaintenancePage'

export default MaintenancePage
